"use client";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { BookOpen, FileText, Lightbulb, Video, Download, MessageCircle } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const resources = [{
  id: 1,
  title: "Getting Started Guide",
  description: "Learn the basics and get up to speed quickly with our comprehensive guide.",
  icon: BookOpen,
  link: "#"
}, {
  id: 2,
  title: "Documentation",
  description: "Explore detailed technical documentation and API references.",
  icon: FileText,
  link: "#"
}, {
  id: 3,
  title: "Best Practices",
  description: "Discover tips and techniques to optimize your workflow.",
  icon: Lightbulb,
  link: "#"
}, {
  id: 4,
  title: "Video Tutorials",
  description: "Watch step-by-step video guides and tutorials.",
  icon: Video,
  link: "#"
}, {
  id: 5,
  title: "Downloads",
  description: "Access templates, tools, and other helpful resources.",
  icon: Download,
  link: "#"
}, {
  id: 6,
  title: "Community Forum",
  description: "Connect with others and get answers to your questions.",
  icon: MessageCircle,
  link: "#"
}];
export default function RelatedResources() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return;
}